import React, { ReactElement, useState } from "react";
import { ShareReportProps } from "../types/ShareReportProps";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useTranslation } from "react-i18next";
import { CopyToClipboard } from "react-copy-to-clipboard";

export const ShareReport = (props: ShareReportProps): ReactElement => {
    const { t } = useTranslation("common");
    const getLocaleValue = (key: string) => {
        return t(`inspectionReport.share.${key}`);
    };

    const [displayDialog, setDisplayDialog] = useState(false);

    const onClick = () => {
        if (props.sendAnalyticsEvent) {
            props.sendAnalyticsEvent("share_icon");
        }

        setDisplayDialog(true);
    };

    const onHide = () => {
        setDisplayDialog(false);
    };

    const onCopy = (e: any) => {
        if (props.sendAnalyticsEvent) {
            props.sendAnalyticsEvent("share_clipboard");
        }

        // The button is holding hover focus for some reason, i think the CopyToClipboard is interfering.
        // This puts the button state back to "normal" after click.
        e.currentTarget.blur();
    };

    return (
        <div className="ml-3">
            <Button
                tooltip="Share link"
                tooltipOptions={{ position: "left" }}
                onClick={() => onClick()}
                icon="pi pi-share-alt"
                aria-label="Share report"
                className="share-tooltip p-button-rounded p-button-secondary p-button-text"
            ></Button>
            <Dialog
                className="dialog-medium"
                header="Share report link"
                visible={displayDialog}
                onHide={() => onHide()}
            >
                <p>{getLocaleValue("shareLinkPreamble")}</p>
                <div className="grid p-fluid">
                    <div className="mt-4 col-12">
                        <div className="p-inputgroup">
                            <InputText readOnly value={props.shareLink} />
                            <CopyToClipboard text={props.shareLink}>
                                <Button
                                    tooltip={getLocaleValue(
                                        "copiedToClipboard"
                                    )}
                                    tooltipOptions={{
                                        event: "focus",
                                        position: "left",
                                        hideDelay: 2000
                                    }}
                                    onClick={(e: any) => onCopy(e)}
                                    icon="pi pi-copy"
                                    className="share-copy-link p-button-secondary"
                                />
                            </CopyToClipboard>
                        </div>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};
